module.exports = __webpack_public_path__ + "img/3.8c665aef.jpg";